import { render, staticRenderFns } from "./createAdminFranchiseClinic.vue?vue&type=template&id=7c4213aa&"
import script from "./createAdminFranchiseClinic.vue?vue&type=script&lang=js&"
export * from "./createAdminFranchiseClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports